<div class="checkbox-row">
    <div class="checkbox-container">
        <label class="radio-container" tabindex="0">
            <div style="display: inline-block; padding-left: 40px; padding-right: 40px; font-size: 14px;">{{answer}}</div>
            <input type="radio" (click)="answerQuestion(nextQuestion,answer);" style="display:none;" [value]="0"/>
            <span class="checkmark" style="display: inline-block; width:25px;"></span>
        </label>
    </div> 
</div>